// ngx-ui-loader.config.ts
import { NgxUiLoaderConfig } from 'ngx-ui-loader';

export const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsColor: "#D5D5D5",
    bgsOpacity: 0.5,
    bgsPosition: "bottom-center",
    bgsSize: 90,
    bgsType: "chasing-dots",
    blur: 9,
    delay: 0,
    fastFadeOut: true,
    fgsColor: "#D5D5D5",
    fgsPosition: "center-center",
    fgsSize: 90,
    fgsType: "cube-grid",
    gap: 24,
    logoPosition: "center-center",
    logoSize: 220,
    logoUrl: "",
    masterLoaderId: "master",
    overlayBorderRadius: "0",
    overlayColor: "rgba(40, 40, 40, 0.8)",
    pbColor: "#D5D5D5",
    pbDirection: "ltr",
    pbThickness: 4,
    hasProgressBar: false,
    text: "",
    textColor: "#FFFFFF",
    textPosition: "center-center",
    maxTime: -1,
    minTime: 300
};
